<template>
    <div>
        <ob-modal2 :show.sync="show" width="600px" :backdrop="false">
        <template slot="modal-title">
            <div class="modal-head">
                <h4 class="modal-title">
                    <span v-if="UploadFormDetails.Link !=''">Update</span><span v-else>Upload</span> Signed Form <span v-if="UploadFormDetails.FormNo ==''">I-539</span><span v-else-if="UploadFormDetails.FormNo ==1">I-539A</span><span v-else>I-539A {{getFormI539ACount(UploadFormDetails.FormNo)}}</span>
                </h4>
            </div>
        </template>
        <template slot="modal-body">
           <div class="row rowgap">
                <div class="col-md-6">
                    <div class="form-group">
                         <label>Signed Date</label><span class="validation-star">*</span>
                          <ob-date-time-picker id="signedDate" v-if="UploadFormDetails.MinDate!=undefined && UploadFormDetails.MinDate != ''" :inputvalue="SignedDate" placeholder="select date" :options="options1" @updated="(v) => this.SignedDate = v"  v-model.trim="SignedDate"  :class="{ 'ob-vuelidate_input-error': $v.SignedDate.$error }" @input="$v.SignedDate.$touch()"></ob-date-time-picker>
                          <ob-date-time-picker id="signedDate" v-else :inputvalue="SignedDate" placeholder="select date" :options="options2" @updated="(v) => this.SignedDate = v"  v-model.trim="SignedDate"  :class="{ 'ob-vuelidate_input-error': $v.SignedDate.$error }" @input="$v.SignedDate.$touch()"></ob-date-time-picker>
                         <span class="ob-vuelidate_error-msg" v-if="$v.SignedDate.$dirty && !$v.SignedDate.required">Enter Signed Date</span>
                    </div>
                </div>
            </div>
            <div  class="row rowgap">
               <div class="col-md-12">
                   <label > Upload Signed Form I-539<span v-if="UploadFormDetails.FormNo !='' && UploadFormDetails.FormNo>=0">A {{getFormI539ACount(UploadFormDetails.FormNo)}}</span></label><span class="validation-star">*</span>
                   <transition name="slide-fade">
                        <div v-if="show">
                            <p style="font-style: italic; margin-bottom: 10px; font-size: 12px;">We accept either pdf, .doc, .docx, zip, images upto 100MB.</p>
                            <ob-upload-new ref="child1" :end-point="EndPoint" :type="2"
                                :IsFileExists="docUrl | I9URL2FileName" :validation="documantValidation" :isUploading.sync="isUploading"
                                @remove-file="removeDocUrl"
                                @file-complete="uploadComplete">
                                <template slot="file-text">
                                    <i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop   OR   Choose  The File
                                </template>

                            </ob-upload-new>
                            <span class="ob-vuelidate_error-msg" style="padding-left: 5px"  v-if="isErrorMessageDisabled && $refs.child1.Errors.length==0" >{{errorMessageFrmResponse}} </span>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-else-if="$v.docUrl.$dirty && !$v.docUrl.required">Please upload document</span>
                        </div>
                    </transition>
               </div>
           </div>
        </template>

        <template slot="modal-footer" class="modal-footer">
             <ob-button type="secondary" @click="cancelForm">Cancel</ob-button>
             <ob-button type="primary"  :disabled="isUploading" @click="onUpload"><span v-if="UploadFormDetails.Link !=''">Update</span><span v-else>Upload</span></ob-button>
             
        </template>
    </ob-modal2>
    </div>
</template>
<script>
import c from 'Vue/Core/constants.js'
import { required, minLength, maxLength, requiredIf, email, alpha, minValue ,maxValue } from 'vuelidate/lib/validators'

export default {
    props: ["openModal","UploadFormDetails"],
    
   data(){
       return{
           show: '',
           SignedDate:'',
           isErrorMessageDisabled: false,
            errorMessageFrmResponse:'',
           //upload doc
                 docUrl:'',
                 EndPoint: `${c.APIBASEURL}/File/FileUpload`,
                 isUploading: false,
                 documantValidation: {
                        Rules: {
                            Type: ["pdf", "zip", "doc", "docx", "png", "gif", "jpg", "jpeg"],
                            Size: 110000000, // In Bytes
                            multiplefiles: false
                        },
                        Messages: {
                            Type: "Please upload valid file formats",
                            Size: `Please upload a file which is less than 100MB`,
                        }
                   },
                   options1: {
                    minDate: moment(this.UploadFormDetails.MinDate).format('MM/DD/YYYY'),
                    maxDate: moment().add(0, 'days'),
                    format: 'MM/DD/YYYY',
                    dayViewHeaderFormat: 'MM/DD/YYYY',
                    widgetPositioning: {
                        horizontal: "auto",
                        vertical: "bottom"
                    },
                }, 
                options2:{
                     maxDate: moment().add(0, 'days'),
                    format: 'MM/DD/YYYY',
                    dayViewHeaderFormat: 'MM/DD/YYYY',
                },
                saveType:'',
       }
   } ,
   created()
    {
           this.show = this.openModal;
           this.SignedDate=this.UploadFormDetails.Date != ""?moment(this.UploadFormDetails.Date).format('MM/DD/YYYY'):"";
           this.docUrl=this.UploadFormDetails.Link !=""?this.UploadFormDetails.Link:"";
           this.saveType=this.UploadFormDetails.Link !=""? "updated":"uploaded"
    },
    validations(){
        return{
            "SignedDate":{
                required
             },
             "docUrl":{
                 required
             }
        }
    },
    methods:{
        cancelForm(){
            this.show=false;
            this.$emit('cancel', this.show)
        },
        removeDocUrl()
        {
         this.docUrl = ''
        },
        uploadComplete(v) {
                if (v[0].response.Url != null)
                {
                    this.docUrl = v[0].response.Url
                    this.isErrorMessageDisabled=false
                }
                if (v[0].response.State==false && v[0].response.Message!=null)
                {
                this.$refs.child1.CancelUpload()
                this.isErrorMessageDisabled=true
                this.errorMessageFrmResponse=v[0].response.Message
                }
        },
        onUpload(){
            this.$v.SignedDate.$touch();
            this.$v.docUrl.$touch();
            if(this.$v.SignedDate.$invalid==false&& this.$v.docUrl.$invalid==false){
                this.$loading({'loadingText' : this.saveType=='updated'?'Updating.....':'Uploading.....'})
                  let FormDetails={
                      "formI539Id": this.UploadFormDetails.UploadFormId,
                      "formI539AId": this.UploadFormDetails.UploadFormAId,
                      "documentType": this.UploadFormDetails.UploadFormAId==''?"FormI539":"FormI539A",
                      "signedAndCompletedDateTime": this.SignedDate,
                     "id":'',
                     "title": this.UploadFormDetails.UploadFormAId==''?"FormI539":"FormI539A",
                     "issuingAuthority": "",
                     "number": "",
                      "expirationDate": "",
                     "link": this.docUrl,
                     "backCopyLink": "",
                     
                    }
            ajax.put(`FormI539/UploadDocument`, FormDetails, (res) =>{
                if(res.data.state == true){
                    this.$loading().close() 
                    this.$message({
                        type: 'success',
                        message: `Document ${this.saveType} successfully`
                    })
                    this.show=false;
                    this.$emit('cancel', this.show)
                    events.fire("LoadI539Details")
                }
                else{
                    this.show=false;
                   this.$emit('cancel', this.show)
                   this.$loading().close() 
                   
                   this.$message({
                       type: 'error',
                       message: res.data.message
                    })
                }
            })
            }
        },
        getFormI539ACount(i539A){
        if(i539A==2){
          return " I" ;
        }
        else if(i539A==3){
            return " II"
        }
        else if(i539A==4){
            return " III"
        }
        else if(i539A==5){
            return " IV"
        }
    },
    }  
}
</script>
<style lang="scss" scoped>
.rowgap {
    margin-top: 10px;
  }
  .title-content {
    color: #4a90e2;
    font-size: 12px;
  }
  .validation-star{
            color: #F31D1D;
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI539/UploadSignedForm.vue